/**
 * Lens registry for CASCADES projections
 */

import type { CascadeLens } from '../types';
import { sequentialLens } from './sequential';
import { filteredLens } from './filtered';
import { fullLens } from './full';

export const lensRegistry: Record<string, CascadeLens> = {
  full: fullLens,
  sequential: sequentialLens,
  filtered: filteredLens,
};

export const getLens = (lensId: string): CascadeLens => {
  const lens = lensRegistry[lensId];
  if (!lens) {
    throw new Error(`Unknown lens: ${lensId}`);
  }
  return lens;
};

export const getLensIds = (): string[] => {
  return Object.keys(lensRegistry);
};

export { sequentialLens, filteredLens };